import React from 'react'
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap'
import TitleIcon from '../../assets/img/title-icon.png';
//images
import DivisionImg1 from '../../assets/img/race kit.png'
import DivisionImg2 from '../../assets/img/division-104k.png';
import DivisionImg3 from '../../assets/img/division-29k.png';

import SmallTitleIcon from '../../assets/img/sm-title-icon.png';

const Division = ({language}) => {
    const divisions = [
        {
            key: "first",
            name: language === "Chinese" ? "103K 挑戰組" : "103K The Race",
            fee: language === "Chinese" ? "NT$：4,500元" : "NT$4,500",
            age: language === "Chinese" ? "7歲以上（未滿16歲須附監護人同意書）" : "Ages 7 and over (under 16 requires a parental/guardian consent form)",
            start: language === "Chinese" ? "06:00-06:20（分波出發）" : "06:00-06:20 (wave starts)",
            limit: language === "Chinese" ? "6小時（依出發波次，12:00-12:20關門）" : "6 hours (finish cut-off 12:00-12:20, depending on start wave)",
            awards: language === "Chinese" ? "男女組前三名敘獎；設登山王（KOM）" : "Top 3 men and women awarded; King of the Mountains (KOM) classification",
            ebike: false,
            is103: true,
        },
        {
            key: "third",
            name: language === "Chinese" ? "103K 電輔車組" : "103K E-bike",
            fee: language === "Chinese" ? "NT$：4,500元" : "NT$4,500",
            age: language === "Chinese" ? "7歲以上（未滿16歲須附監護人同意書）" : "Ages 7 and over (under 16 requires a parental/guardian consent form)",
            start: language === "Chinese" ? "06:00-06:20（於最後一波出發）" : "06:00-06:20 (starts in the last wave)",
            limit: language === "Chinese" ? "6小時（依出發波次，12:00-12:20關門）" : "6 hours (finish cut-off 12:00-12:20, depending on start wave)",
            awards: language === "Chinese" ? "無敘獎" : "No awards",
            ebike: true,
            is103: true,
        },
        {
            key: "second",
            name: language === "Chinese" ? "28K 經典組" : "28K The Ride",
            fee: language === "Chinese" ? "NT$：3,500元" : "NT$3,500",
            age: language === "Chinese" ? "不限年齡（未滿16歲須附監護人同意書）" : "No age limit (under 16 requires a parental/guardian consent form)",
            start: language === "Chinese" ? "06:30-06:40（分波出發）" : "06:30-06:40 (wave starts)",
            limit: language === "Chinese" ? "4小時（依出發波次，10:30-10:50關門）" : "4 hours (finish cut-off 10:30-10:50, depending on start wave)",
            awards: language === "Chinese" ? "男女組前三名敘獎" : "Top 3 men and women awarded",
            ebike: false,
            is103: false,
        },
        {
            key: "fourth",
            name: language === "Chinese" ? "28K 電輔車組" : "28K E-bike",
            fee: language === "Chinese" ? "NT$：3,500元" : "NT$3,500",
            age: language === "Chinese" ? "不限年齡（未滿16歲須附監護人同意書）" : "No age limit (under 16 requires a parental/guardian consent form)",
            start: language === "Chinese" ? "06:30-06:40（於最後一波出發）" : "06:30-06:40 (starts in the last wave)",
            limit: language === "Chinese" ? "4小時（依出發波次，10:30-10:50關門）" : "4 hours (finish cut-off 10:30-10:50, depending on start wave)",
            awards: language === "Chinese" ? "無敘獎" : "No awards",
            ebike: true,
            is103: false,
        },
    ];

    return (
        <section className="event-division">
            <Container>
                <h2 className='event-title'><span><img className='title-icon' src={TitleIcon} alt="" /></span>{language === "Chinese" ? "活動組別" : "Categories"}</h2>
                <Row className='align-items-center'>
                    <Col>
                        <Tab.Container id="projects-tabs" defaultActiveKey="first">
                            <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                                {divisions.map((d) => (
                                    <Nav.Item key={d.key}>
                                        <Nav.Link eventKey={d.key}>{d.name}</Nav.Link>
                                    </Nav.Item>
                                ))}
                            </Nav>
                            <Tab.Content id="slideInUp">
                                {divisions.map((d) => (
                                <Tab.Pane eventKey={d.key} key={d.key}>
                                    <Row className='align-items-center'>
                                        <Col md={6}>
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <td className='division-table-left'>{language === "Chinese" ? "報名費" : "Entry Fee"}</td>
                                                        <td className='division-table-right'>{d.fee}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='division-table-left'>{language === "Chinese" ? "參加資格" : "Age Requirement"}</td>
                                                        <td className='division-table-right'>{d.age}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='division-table-left'>{language === "Chinese" ? "計時方式" : "Timing Method"}</td>
                                                        <td className='division-table-right'>{language === "Chinese" ? "晶片計時（拋棄式晶片，免押金、免歸還）" : "Chip timing (disposable chip; no deposit, no need to return it)"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='division-table-left'>{language === "Chinese" ? "集合時間" : "Assembly Time"}</td>
                                                        <td className='division-table-right'>05:00-05:30</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='division-table-left'>{language === "Chinese" ? "鳴槍時間" : "Start Time"}</td>
                                                        <td className='division-table-right'>{d.start}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='division-table-left'>{language === "Chinese" ? "時間限制" : "Time Limit"}</td>
                                                        <td className='division-table-right'>{d.limit}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='division-table-left'>{language === "Chinese" ? "敘獎" : "Awards"}</td>
                                                        <td className='division-table-right'>{d.awards}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='division-table-left'>{language === "Chinese" ? "衣物保管時間" : "Bag Drop Hours"}</td>
                                                        <td className='division-table-right'>05:00-13:30</td>
                                                    </tr>
                                                    <tr>
                                                        {language === "Chinese" ? <td className='division-table-left'>環法挑戰賽限定選手物資<br />（價值：NT$7,820元）</td>
                                                            : <td className='division-table-left'>Race Kit: L’Étape Exclusive Race Kit<br />(Value: NT$7,820)</td>}
                                                        <td className='division-table-right'>
                                                            <ul className='ul-decimal text-start ms-5'>
                                                                <li>{language === "Chinese" ? "環法限定運動背包（deya）" : "L’Étape Exclusive Sports Backpack (deya)"}</li>
                                                                <li>{language === "Chinese" ? "Titan 襪子" : "Titan Socks"}</li>
                                                                <li>{language === "Chinese" ? "BONE 煞車綁" : "BONE Bike Tie"}</li>
                                                                <li>{language === "Chinese" ? "晶片車貼＋號碼布" : "Bike Chip Sticker + Race Number"}</li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='division-table-left'>{language === "Chinese" ? "完賽禮" : "Finisher Items"}</td>
                                                        <td className='division-table-right'>
                                                            <ul className='ul-decimal text-start ms-5'>
                                                                <li>{language === "Chinese" ? "完賽獎牌" : "Finisher Medal"}</li>
                                                                <li>{language === "Chinese" ? "完賽證書" : "Finisher Certificate"}</li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='division-table-left'>{language === "Chinese" ? "備註" : "Note"}</td>
                                                        {language === "Chinese" ? <td className='division-table-right text-start'>
                                                                {d.is103 ? <>※中途關門點：台21線甲線20K+815頭社派出所前路口，關門時間11:00；逾時者請直接折返向山會場。<br /></> : <>※28K採順時針方向環湖，請勿騎入103K路線。<br /></>}
                                                                ※未能於時限內完賽者，將無法取得完賽證書。<br />
                                                                ※關門時間過後，後續的原活動路段的交維志工將撤哨，結束服務。<br/>
                                                                {d.ebike ? "※電輔車組於最後一波出發，且無設置敘獎、黃衫、登山王。" : "※電輔車另設電輔車組，於最後一波出發，且無設置敘獎、黃衫、登山王。"}
                                                            </td>
                                                            : <td className='division-table-right text-start'>
                                                                {d.is103 ? <>* Intermediate cut-off: 11:00 at the junction in front of Toushe Police Station (Provincial Highway 21A, 20K+815). Riders who miss it must ride straight back to the Xiangshan venue.<br /></> : <>* The 28K rides the lake loop clockwise. Do not enter the 103K route.<br /></>}
                                                                * Riders who do not finish within the time limit will not receive a Finisher Certificate.<br />
                                                                * After the cut-off time, traffic control volunteers along the remaining route will stand down and end their service.<br />
                                                                {d.ebike ? "* E-bike riders start in the last wave. There are no awards, Yellow Jersey, or King of the Mountains (KOM) classification for e-bikes." : "* E-bikes have their own separate category, starting in the last wave, with no awards, Yellow Jersey, or King of the Mountains (KOM) classification."}
                                                            </td>}
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Col>
                                        <Col md={6} className='px-2'>
                                            <div className="division-img-bx">
                                                <img src={DivisionImg1} alt={language === "Chinese" ? "環法挑戰賽限定物資" : "Race kit"} />
                                                <a href="/race-kit"><h4><span><img src={SmallTitleIcon} alt="" /></span>{language === "Chinese" ? "點我看環法挑戰賽限定物資" : "View race kit details"}</h4></a>
                                            </div>
                                            {d.is103 ?
                                                <div className="division-img-bx">
                                                    <img src={DivisionImg2} alt={language === "Chinese" ? "103K挑戰組路線" : "103K The Race route"} />
                                                    <a href="/104k-route"><h4><span><img src={SmallTitleIcon} alt="" /></span>{language === "Chinese" ? "點我看103K路線" : "View the 103K route"}</h4></a>
                                                </div>
                                                :
                                                <div className="division-img-bx">
                                                    <img src={DivisionImg3} alt={language === "Chinese" ? "28K經典組路線" : "28K The Ride route"} />
                                                    <a href="/29k-route"><h4><span><img src={SmallTitleIcon} alt="" /></span>{language === "Chinese" ? "點我看28K路線" : "View the 28K route"}</h4></a>
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                </Tab.Pane>
                                ))}
                            </Tab.Content>
                        </Tab.Container>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Division
